/**
 * KAN-744: фильтр списка клиентов "Менеджер": Все / Без менеджера /
 * конкретный менеджер (и из архива: у его клиентов он остаётся). Пока
 * менеджеры не загружены или загрузка упала, фильтр скрыт.
 * KAN-782: с пропом label над селектом рисуется подпись (скрывается вместе
 * с фильтром) и триггер растёт по содержимому; без label (OrdersPage)
 * селект рисуется как раньше.
 */
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useManagers } from '@/hooks/useManagers';
import { FILTER_TRIGGER_CLASS, FilterField } from './FilterField';
import { ALL_MANAGERS, NO_MANAGER } from './useClientListFilters';

interface Props {
  value: string;
  onChange: (value: string) => void;
  /** Подпись над селектом (KAN-782); без неё селект рисуется как раньше. */
  label?: string;
}

export function ManagerFilter({ value, onChange, label }: Props): JSX.Element | null {
  const { data: managers } = useManagers('all');
  if (!managers) return null;
  const select = (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger
        data-testid="manager-filter"
        aria-label="Менеджер"
        className={label ? FILTER_TRIGGER_CLASS : 'w-full sm:w-48'}
      >
        <SelectValue placeholder="Менеджер" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL_MANAGERS}>Все менеджеры</SelectItem>
        <SelectItem value={NO_MANAGER}>Без менеджера</SelectItem>
        {managers.map((m) => (
          <SelectItem key={m.id} value={m.id}>
            {m.is_active ? m.full_name : `${m.full_name} (архив)`}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
  return label ? <FilterField label={label}>{select}</FilterField> : select;
}
